
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { Observer } from 'mobx-vue'
import { EnumMyAccountMenu } from '@xt/client/enums/my'
import TooltipPop from '../../../views/ToolPopover/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'

@Observer
@Component({
  components: {
    InfiniteLoading,
    TooltipPop,
    EmptyStatus
  }
})
export default class MyAccountBishan extends Vue {
  tooltipText: {
    title: string
    content: string[]
  } = {
    title: '如何获得笔山',
    content: [
      '1. 笔山可通过观看课程直播回放、交作业、参加展览闯关或参与教室活动获得。笔山不能兑现，不可转让。',
      '2. 笔山可用于兑换文房券（文房券即满减券，可在暄桐文房微信店铺的文房券专区使用）。',
      '3. 笔山的有效期为两年, 每季度最后1天集中清理过期笔山。',
      '例如：您在2020年1月1日获得10个笔山积分，该笔山的有效期至2022年3月31日23：59：59。',
      '4. 使用笔山兑换时，优先消耗即将到期的笔山。'
    ]
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get pagePagination() {
    return this.$store.$myV2.Account.BiShan.pagePagination
  }

  get PageStore() {
    return this.$store.$myV2.Account.BiShan
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  goExchange() {
    this.$router.push({
      name: 'my-account',
      query: {
        menu: EnumMyAccountMenu.Exchange
      }
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
